import { dataUserSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSolid = /*#__PURE__*/createIcon(dataUserSolid)
export default IconUserSolid
